import { render, staticRenderFns } from "./SynergyPopup.vue?vue&type=template&id=97831d24&scoped=true"
import script from "./SynergyPopup.vue?vue&type=script&lang=ts"
export * from "./SynergyPopup.vue?vue&type=script&lang=ts"
import style0 from "./SynergyPopup.vue?vue&type=style&index=0&id=97831d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97831d24",
  null
  
)

export default component.exports